/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var Image = defineComponent({
  name: "Image",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
Image.install = function (app) {
  app.component(Image.name, Image);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 12H40V36H34.4479C32.9041 28.1972 21.9086 21.9859 8 21.0197V12ZM4 24.8893V20.8893V12C4 9.79086 5.79086 8 8 8H40C42.2091 8 44 9.79086 44 12V36C44 38.2091 42.2091 40 40 40H34.4013H30.2287H8C5.79086 40 4 38.2091 4 36V24.8893ZM30.3083 36H8V25.03C14.2731 25.501 19.7562 27.1168 23.7709 29.36C27.5607 31.4775 29.5765 33.8421 30.3083 36Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

Image.render = render;

export { Image as default };
